import Ionicons from "@expo/vector-icons/Ionicons";

export type IoniconsType = keyof typeof Ionicons.glyphMap;
